import { Controller } from "@hotwired/stimulus"

// Tiny generic dropdown : adds .is-open on the root element and toggles a
// targeted menu. Compatible with the saved-views tabs and any future widget.
export default class extends Controller {
  static targets = ["menu"]

  toggle(event) {
    event?.stopPropagation()
    this.element.classList.toggle("is-open")
  }

  close() {
    this.element.classList.remove("is-open")
  }

  hideOnOutsideClick(event) {
    if (this.element.contains(event.target)) return
    this.close()
  }
}
